import React, { Component } from "react";
import "./App.css";
import { styles } from "./css-common"
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import TrackRecord from  "./components/trackRecord";

import { AppBar, Toolbar, Typography, withStyles } from '@material-ui/core';

class App extends Component {
  render() {
    const { classes } = this.props

    return (
      <div>
        <Routes>
    <Route path="/" element={<TrackRecord/>} />
   

</Routes>
      </div>
    );
  }
}

export default withStyles(styles)(App);